import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchRequestWithAuth } from '~/lib/api';

interface PhoneUpdateData {
  phone_number: string;
  whatsapp_consent?: boolean;
}

export function useUpdatePhone() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PhoneUpdateData) =>
      patchRequestWithAuth('/api/v1/users/me/phone', data),
    onSuccess: () => {
      // Invalidate user query to refresh phone number
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
    },
  });
}
